import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import React from 'react';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { store } from '../../../../../store/store';
import { loadDOMComponent } from '../../../../../helpers';
import InvoicingWrapper from './InvoicingWrapper';
import { parseBoolean } from '../../../../../Utils/form.util';

loadDOMComponent({
	selector: 'react-invoicing',
	callback: ({ container, context }: any) => {
		const isSuperAdmin = container.getAttribute('isSuperAdmin');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<InvoicingWrapper isSuperAdmin={parseBoolean(isSuperAdmin)} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
